import React from "react";
import { Table } from "src/modules/CustomerNoticeCertification/Table";
interface Props {
  systemId?: string;
  submissionPeriodId?: number;
  isOnUtilityDetailsPage?: boolean;
}

export const CustomerNoticeSubmissionTable: React.FC<Props> = ({
  systemId,
  submissionPeriodId,
  isOnUtilityDetailsPage,
}) => {
  return (
    <Table
      systemId={systemId}
      submissionPeriodId={submissionPeriodId}
      isOnUtilityDetailsPage={isOnUtilityDetailsPage}
    />
  );
};
